import React from 'react';

import { CCard } from './styles';

export interface CreditCardImageProps {
  isFlipped: boolean;
  cardType: string;
  cardNumber: string;
  holderName: string;
  expiryDate: string;
  cvv: string;
}

const CreditCardImage = ({ cardType, cardNumber, holderName, expiryDate, cvv, isFlipped }: CreditCardImageProps) => (
  <>
    {!isFlipped ? (
      <CCard className="front">
        <CCard.Chip />
        <CCard.Flag className={cardType !== '' ? `${cardType.toLowerCase()}` : ''}></CCard.Flag>
        <CCard.Number>{cardNumber}</CCard.Number>
        <CCard.HolderName>{holderName}</CCard.HolderName>
        <CCard.Expiry>{expiryDate}</CCard.Expiry>
      </CCard>
    ) : (
      <CCard className="back">
        <CCard.Cvv>{cvv}</CCard.Cvv>
      </CCard>
    )}
  </>
);

export default CreditCardImage;
